export const ateliersFields =
[
    {
        name: "atelier_id",
        type: "text",
        visible: false,
        allowCreating: false,
        allowUpdating: false
    },
    {
        name: "nom",
        type: "text",
        visible: true,
        allowCreating: true,
        allowUpdating: true
    },
    {
        name: "duree",
        type: "number",
        visible: true,
        allowCreating: true,
        allowUpdating: true
    },
    {
        name: 'actif',
        type: "checkbox",
        visible: true,
        allowCreating: true,
        allowUpdating: true
    }
];

export const zonesFields = [
    {
        name: "zone_id",
        type: "text",
        visible: false,
        allowCreating: false,
        allowUpdating: false
    },
    {
        name: "nom",
        type: "text",
        visible: true,
        allowCreating: true,
        allowUpdating: true
    },
]

